/**
 * Step 2: Parsing Progress
 */

import { Card, Space, Progress, Alert, Button, Typography } from 'antd'
import {
  LoadingOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons'

const { Text, Title } = Typography

interface ParsingStepProps {
  projectName?: string | null
  projectCrmId?: number | null
  progress: number
  statusMessage: string
  parsingFailed: boolean
  onRetry: () => void
  onClose: () => void
}

export default function ParsingStep({
  projectName,
  projectCrmId,
  progress,
  statusMessage,
  parsingFailed,
  onRetry,
  onClose,
}: ParsingStepProps) {
  if (parsingFailed) {
    return (
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Alert
          message="Ошибка парсинга"
          description={statusMessage}
          type="error"
          showIcon
          icon={<CloseCircleOutlined />}
        />
        <Space style={{ width: '100%' }}>
          <Button type="primary" onClick={onRetry} block>
            Попробовать снова
          </Button>
          <Button onClick={onClose}>
            Закрыть
          </Button>
        </Space>
      </Space>
    )
  }

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      {/* Main status card with gradient */}
      <Card
        bordered={false}
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
        }}
      >
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <LoadingOutlined style={{ fontSize: 32 }} spin />
            <div style={{ flex: 1 }}>
              <Title level={4} style={{ margin: 0, color: 'white' }}>
                Парсинг выполняется
              </Title>
              <Text style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: 14 }}>
                {projectName || `Проект ${projectCrmId}`}
              </Text>
            </div>
            <div style={{ textAlign: 'right' }}>
              <Text style={{ color: 'white', fontSize: 32, fontWeight: 700 }}>
                {Math.round(progress)}%
              </Text>
            </div>
          </div>
        </Space>
      </Card>

      {/* Progress with steps */}
      <Card size="small">
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Progress
            percent={progress}
            status="active"
            strokeColor={{
              '0%': '#667eea',
              '100%': '#764ba2',
            }}
            format={(percent) => `${Math.round(percent || 0)}%`}
          />

          <div style={{
            padding: '12px 16px',
            background: '#f5f5f5',
            borderRadius: 8,
            border: '1px solid #e8e8e8'
          }}>
            <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>
              Текущий этап:
            </Text>
            <Text strong style={{ fontSize: 14 }}>
              {statusMessage || 'Обработка...'}
            </Text>
          </div>
        </Space>
      </Card>

      <Alert
        message="Парсинг выполняется в фоне"
        description="Вы можете закрыть это окно. Парсинг продолжится в фоне. Чтобы вернуться к нему позже - откройте проект снова."
        type="info"
        showIcon
      />
    </Space>
  )
}
